export const callFuncOnEnterKeyDown = function (event, callback) {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault();
      callback(event);
    }
};